import { FixedNumber } from "ethers"
import { XFER } from "src/constants"
import { BIG_ZERO_FIXED } from "src/constants/bigNumber"
import boostPools from "src/constants/boostPools"
import { FER_PER_YEAR } from "src/constants/ferroFarm"
import { useFerroBoostPool } from "src/state/xFer/hooks"
import { getRawAmount } from "src/utils/parseStringToBigNumber"
import usePastWeekApr from "./usePastWeekApr"
import useXFerRate from "./useXFerRate"

// Returns apr in % and 2 decimal places
export const useVaultsApr = (): {
  poolId: number
  apr: string
}[] => {
  const { boostPoolData } = useFerroBoostPool()
  const rate = useXFerRate()
  const pastWeekApr = usePastWeekApr()
  const { poolWeight, totalSupply: vaultTotalSupply, poolInfo } = boostPoolData

  const ratios: FixedNumber[] = poolInfo.map((x) => {
    const mulitiplier =
      boostPools.find((pool) => pool.pid === x.poolId)?.multiplier || 0
    const weigthedStakesFN = FixedNumber.from(x.stakes.mul(mulitiplier))
    const vaultTotalSupplyFN = FixedNumber.from(vaultTotalSupply)
    return vaultTotalSupplyFN.isZero()
      ? BIG_ZERO_FIXED
      : weigthedStakesFN.divUnsafe(vaultTotalSupplyFN)
  })

  const totalXFerRewardPerYear = poolWeight
    .mulUnsafe(FixedNumber.from(FER_PER_YEAR.toString()))
    .divUnsafe(rate)
  const rewards = ratios.map((x) => x.mulUnsafe(totalXFerRewardPerYear))

  const apr = poolInfo.map((x, i) => {
    const stakesFN = getRawAmount(x.stakes, XFER.decimals)
    const pastWeekAprFN = FixedNumber.from(pastWeekApr.toString())
    if (stakesFN.isZero()) {
      return {
        poolId: x.poolId,
        apr: pastWeekAprFN.round(2).toString(),
      }
    } else {
      return {
        poolId: x.poolId,
        apr: rewards[i]
          .divUnsafe(stakesFN)
          .mulUnsafe(FixedNumber.from(100))
          .addUnsafe(pastWeekAprFN)
          .round(2)
          .toString(),
      }
    }
  })
  return apr
}
